// @generated by protoc-gen-es v1.6.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/ampq/chat_notification.proto (package qliq_protobuf.ampq, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { NewMessage } from "./chat/new_message_pb.ts";
import { NewConversation } from "./chat/new_conversation_pb.ts";
import { ReassignConversation } from "./chat/reassign_conversation_pb.ts";
import { ReopenConversation } from "./chat/reopen_conversation_pb.ts";
import { AssigneeUpdate } from "./chat/assignee_update_pb.ts";
import { StatusUpdate } from "./chat/status_update_pb.ts";
import { NotifyChime } from "./chat/notify_chime_pb.ts";
import { ConversationParticipantsUpdate } from "./chat/conversation_participants_update_pb.ts";
import { NewNonqliqMessage } from "./chat/new_nonqliq_message_pb.ts";
import { Command } from "./chat/command_pb.ts";

/**
 * @generated from message qliq_protobuf.ampq.ChatNotification
 */
export class ChatNotification extends Message<ChatNotification> {
  /**
   * @generated from field: repeated uint32 recipient_ids = 1;
   */
  recipientIds: number[] = [];

  /**
   * @generated from field: bool chime = 2;
   */
  chime = false;

  /**
   * @generated from oneof qliq_protobuf.ampq.ChatNotification.payload
   */
  payload: {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.NewMessage new_message = 3;
     */
    value: NewMessage;
    case: "newMessage";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.NewConversation new_conversation = 4;
     */
    value: NewConversation;
    case: "newConversation";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.ReassignConversation reassign_conversation = 5;
     */
    value: ReassignConversation;
    case: "reassignConversation";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.ReopenConversation reopen_conversation = 6;
     */
    value: ReopenConversation;
    case: "reopenConversation";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.AssigneeUpdate assignee_update = 7;
     */
    value: AssigneeUpdate;
    case: "assigneeUpdate";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.StatusUpdate status_update = 8;
     */
    value: StatusUpdate;
    case: "statusUpdate";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.NotifyChime notify_chime = 9;
     */
    value: NotifyChime;
    case: "notifyChime";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.ConversationParticipantsUpdate conversation_participants_update = 10;
     */
    value: ConversationParticipantsUpdate;
    case: "conversationParticipantsUpdate";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.NewNonqliqMessage new_nonqliq_message = 11;
     */
    value: NewNonqliqMessage;
    case: "newNonqliqMessage";
  } | {
    /**
     * @generated from field: qliq_protobuf.ampq.chat.Command command = 12;
     */
    value: Command;
    case: "command";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: string uuid = 13;
   */
  uuid = "";

  constructor(data?: PartialMessage<ChatNotification>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.ampq.ChatNotification";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "recipient_ids", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 2, name: "chime", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "new_message", kind: "message", T: NewMessage, oneof: "payload" },
    { no: 4, name: "new_conversation", kind: "message", T: NewConversation, oneof: "payload" },
    { no: 5, name: "reassign_conversation", kind: "message", T: ReassignConversation, oneof: "payload" },
    { no: 6, name: "reopen_conversation", kind: "message", T: ReopenConversation, oneof: "payload" },
    { no: 7, name: "assignee_update", kind: "message", T: AssigneeUpdate, oneof: "payload" },
    { no: 8, name: "status_update", kind: "message", T: StatusUpdate, oneof: "payload" },
    { no: 9, name: "notify_chime", kind: "message", T: NotifyChime, oneof: "payload" },
    { no: 10, name: "conversation_participants_update", kind: "message", T: ConversationParticipantsUpdate, oneof: "payload" },
    { no: 11, name: "new_nonqliq_message", kind: "message", T: NewNonqliqMessage, oneof: "payload" },
    { no: 12, name: "command", kind: "message", T: Command, oneof: "payload" },
    { no: 13, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatNotification {
    return new ChatNotification().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatNotification {
    return new ChatNotification().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatNotification {
    return new ChatNotification().fromJsonString(jsonString, options);
  }

  static equals(a: ChatNotification | PlainMessage<ChatNotification> | undefined, b: ChatNotification | PlainMessage<ChatNotification> | undefined): boolean {
    return proto3.util.equals(ChatNotification, a, b);
  }
}

